export const styles = {
  modalCustom: {
    "& .ant-modal": {
      top: "50%",
      transform: "translateY(-50%)",
      paddingBottom: 0,
    },
    "& .ant-modal-content": {
      borderRadius: "20px",
      padding: 0,
      width: "100%",
    },
    "& .ant-modal-body": {
      padding: "24px 32px 32px 32px",
      display: "flex",
      flexDirection: "column",
      gap: "24px",
    },
    "& .ant-modal-close": {
      top: "24px",
      right: "32px",
      "& .ant-modal-close-x": {
        width: "32px",
        height: "32px",
        lineHeight: "32px",
        fontSize: "14px",
        borderRadius: "8px",
        backgroundColor: "#F1F5F9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
          backgroundColor: "#E2E8F0",
        },
        "& svg": {
          width: "16px",
          height: "16px",
        },
      },
    },
    "& .header": {
      "& .title": {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        fontSize: "24px",
        fontWeight: 600,
        color: "#0F172A",
        margin: 0,
        lineHeight: "32px",
        "& svg": {
          display: "block",
          marginTop: "-2px",
        },
      },
    },
    "& .filter-fields": {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    "& .field": {
      width: "100%",
      "& > div": {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        width: "100%",
      },
      "& .label": {
        fontSize: "14px",
        fontWeight: 500,
        color: "#475569",
      },
      "& .ant-select": {
        width: "100%",
        "& .ant-select-selector": {
          height: "52px !important",
          borderRadius: "12px !important",
          border: "1px solid #E2E8F0 !important",
          padding: "0 16px !important",
          display: "flex",
          alignItems: "center",
          "&:hover": {
            borderColor: "#CBD5E1 !important",
          },
        },
        "&.ant-select-focused .ant-select-selector": {
          borderColor: "#3B82F6 !important",
          boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.1) !important",
        },
        "& .ant-select-arrow": {
          color: "#64748B",
        },
        "& .ant-select-selection-placeholder": {
          color: "#94A3B8",
          fontSize: "15px",
          lineHeight: "52px",
          display: "flex",
          alignItems: "center",
        },
        "& .ant-select-selection-item": {
          lineHeight: "50px",
        },
      },
    },
    "& .buttons-area": {
      display: "flex",
      justifyContent: "flex-end",
      gap: "12px",
      marginTop: "8px",
      "& button": {
        flex: "0 0 auto",
        minWidth: "140px",
        padding: "0 24px",
        height: "40px",
        borderRadius: "8px",
        fontSize: "16px",
        fontWeight: 500,
        cursor: "pointer",
        transition: "all 0.2s ease",
        border: "none",
        outline: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&.btn-clear": {
          backgroundColor: "transparent",
          color: "#0F172A",
          border: "1px solid #0F172A",
          "&:hover": {
            backgroundColor: "#F8FAFC",
          },
          "&:active": {
            backgroundColor: "#F1F5F9",
          },
        },
        "&.btn-apply": {
          backgroundColor: "#DC2626",
          color: "#FFFFFF",
          "&:hover": {
            backgroundColor: "#B91C1C",
          },
          "&:active": {
            backgroundColor: "#991B1B",
          },
          "&:disabled": {
            backgroundColor: "#E5E7EB",
            color: "#9CA3AF",
            cursor: "not-allowed",
            opacity: 1,
          },
        },
      },
    },
  },
  headerTitle: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
  cardHeader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "100%",
  },
  subtitleText: {
    fontSize: "16px",
    fontWeight: "400",
    marginBottom: "24px",
    color: "#475569",
  },
  filtersArea: {
    display: "flex",
    alignItems: "flex-end",
    gap: "16px",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  filtersSearch: {
    flex: "1 1 300px",
    minWidth: "250px",
    maxWidth: "100%",
  },
  filterButton: {
    position: "relative",
  },
  breakWord: {
    wordBreak: "break-word",
    whiteSpace: "normal",
  },
  errorIconCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
};
